// 登录页面
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Button, Form, Input, Checkbox, App, Spin } from 'antd';
import { UserOutlined, UnlockOutlined, InsuranceOutlined } from '@ant-design/icons';
import './index.css'
import logo from '@/common/img/logo.svg'
import { universalLogin, universalGetUserInfo, getLoginVerifyApi } from '@/server/login'
import { getAllPermissions } from '@/server/home.js'
// import store from '@/store';

function Login () {
  const { message } = App.useApp();
  const location = useLocation();//接受传值数据

  const navigate = useNavigate();
  const [btn_load, setBtnLoad] = useState(false);//按钮加载事件
  // const [isUrlLogin, setIsUrlLogin] = useState(true);//是否是url登录

  const codeUrl = '/api/admin.php?service=Admin.Common.CreateCaptcha'
  const [isNeedCode, setIsNeedCode] = useState(false)//是否需要验证码

  const isUrlLogin = useRef(false)
  const [form] = Form.useForm();

  //提交
  const onFinish = async (e, name = null, password = null) => {
    setBtnLoad(true);
    let res = await universalLogin({
      username: name ? name : e?.username,
      password: password ? password : e?.password,
      captcha: e ? e?.code : undefined,
    });

    if (res.ret !== 200) {
      message.error(res.msg || '服务器开了小差，请重试')
      setIsNeedCode(true)
      setTimeout(() => {
        isUrlLogin.current = false
        let imgDom = document.getElementById('ChangeCode')
        imgDom.src = codeUrl
      }, 800);
      setTimeout(() => {
        setBtnLoad(false);
      }, 500);
      return
    }
    setIsNeedCode(false)
    localStorage.setItem('dock_userName', name ? name : e.username);
    // 获取当前账号角色，并展示不同的菜单
    const res1 = await universalGetUserInfo({
      access_token: res.data.access_token,
    });
    localStorage.setItem('dock_isLogin', true);
    localStorage.setItem('dock_token', res.data.access_token);
    localStorage.setItem('dock_memberLevel', res1.data.profile.member_level)


    //获取权限
    let per = await getAllPermissions({
      access_token: res.data.access_token,
      member_level: res1.data.profile.member_level
    })
    if (per.ret !== 200) { message.warning(per.msg); return }
    if (per.data.menuids && per.data.menuids.length) {
      window.localStorage.setItem('dock_AirportPermissionsArr', JSON.stringify(per.data.menuids));
      window.localStorage.setItem('dock_AirportPermissionsArrName', JSON.stringify(per.data.menuName));
    } else {
      window.localStorage.setItem('dock_AirportPermissionsArr', '');
      window.localStorage.setItem('dock_AirportPermissionsArrName', '');
    }
    setTimeout(() => { setBtnLoad(false); }, 500);
    message.success('登录成功')
    setTimeout(() => { navigate('/routine_list_conduit'); }, 500)
  }


  const loginVerify = async (values) => { //登陆前的验证
    let res = await getLoginVerifyApi({ username: values.username })
    if (res.data.verify) {
      setIsNeedCode(true)
    } else {
      onFinish(values)
    }
  }

  //忘记密码
  const forget = () => {
  }

  useEffect(() => {
    let username = localStorage.getItem('dock_userName') ?? '';
    localStorage.clear();
    localStorage.setItem('dock_userName', username);
    form.setFieldsValue({
      username: username,
      remember: true,
    }) //表单赋值
    //eslint-disable-next-line
  }, [])


  useEffect(() => {
    if (location.search) {
      isUrlLogin.current = true
      let params = new URLSearchParams(location.search)
      let getUserName = params.get('username')
      let getPassword = params.get('password')
      if (getUserName || getPassword) {
        onFinish(null, getUserName, getPassword)
      }
    }
    //eslint-disable-next-line
  }, [location.search])

  return (
    <div className='main_div'>
      {
        isUrlLogin.current
          ? (
            <>
              <Spin className='pos_abs wid100 hei100 align_center jcc flex ' spinning={true}></Spin>
            </>
          )
          : (
            <>
              <div>
                {/* 头部 */}
                <div className='logo_div'>
                  <img src={logo} className='img' alt='logo'></img>
                  <div className='font'> 管理系统-本地化部署</div>
                </div>
                {/* 表单主体 */}
                <div className='pdT78' style={{ width: '360px' }}>
                  <Form name="basic"
                    onFinish={isNeedCode ? onFinish : loginVerify}//验证码存在则直接调用登录，验证码不存在则调用验证
                    form={form}
                    autoComplete="off"
                  >
                    <Form.Item name="username"
                      rules={[{ required: true, message: '请输入用户名', },]}
                    >
                      <Input size="large" prefix={<UserOutlined style={{ color: '#1890FF', height: '24px' }} />} />
                    </Form.Item>

                    <Form.Item name="password"
                      rules={[{ required: true, message: '请输入密码', },]}
                    >
                      <Input.Password size="large" prefix={<UnlockOutlined style={{ color: '#1890FF', height: '24px' }} />} />
                    </Form.Item>

                    {
                      isNeedCode && codeUrl &&
                      <Form.Item
                        className='h40'
                        name="code"
                        rules={[
                          {
                            required: true,
                            message: '请输入验证码',
                          },
                        ]}
                      >
                        <div className='h40 flex jcsb align_center'>
                          <Input
                            className='h40 marR8'
                            size="large"
                            prefix={<InsuranceOutlined className="site-form-item-icon" style={{ color: '#007be4' }} />}
                            // type="password"
                            placeholder="验证码"
                            style={{ width: 'calc(100% - 168px)' }}
                          />
                          <img
                            className='radius8'
                            id='ChangeCode'
                            src={codeUrl}
                            alt='验证码'
                            onClick={() => {
                              let imgDom = document.getElementById('ChangeCode')
                              imgDom.src = codeUrl
                            }}
                          />
                        </div>
                      </Form.Item>
                    }






                    <div className='flex_row justify_between align_center'>
                      <Form.Item name="remember"
                        valuePropName="checked"
                      >
                        <Checkbox>记住此账号</Checkbox>
                      </Form.Item>
                      <Form.Item>
                        <div
                          type="link"
                          className='col_primary pointer'
                          onClick={forget}>
                          忘记密码？
                        </div>
                      </Form.Item>

                    </div>
                    <div>
                      <Button id='loginBtn' size="large" type="primary" htmlType="submit" className='wid100 bc_primary' loading={btn_load} >
                        登录
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
              {/* 底部 */}
              <div>
                <div className="tc marB10">
                  <font className="fs14 col_secondary_text marR40">玖舟智能科技</font>
                  <font className="fs14 col_secondary_text">Ant Design</font>
                </div>
                <div className="tc lh22 col_secondary_text marB27">
                  Copyright ©2022 Produced by You Zhou Group Technology Department
                </div>
              </div>


            </>
          )


      }

    </div >

  )
}
export default Login